function isFirstRound() {
  if (this.round.allow_suggestions && this.categories.length !== 0) {
    return this.categories.every((category) => category.nomineeIds.length === 0)
  }
  return false
}

export default isFirstRound



// WEBPACK FOOTER //
// ./src/util/firstRound.js